import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms';
import { ComponentsModule } from '@fcom/common/components';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import {
  OndMarketingLandingCoreModule,
  OndMarketingOffersService,
  OndMarketingDataService,
} from '@fcom/ond-marketing-landing-core';
import { OndMarketingListingComponent } from '@fcom/ond-marketing-landing/components/ond-marketing-listing.component';

import { OndMarketingLandingRouteModule } from './ond-marketing-landing.routes';
import { OndMarketingLandingComponent } from './components/ond-marketing-landing.component';

@NgModule({
  imports: [
    OndMarketingLandingRouteModule,
    CommonModule,
    OndMarketingLandingCoreModule,
    UiTranslateModule,
    PipesModule,
    ComponentsModule,
    CmsModule,
  ],
  providers: [OndMarketingOffersService, OndMarketingDataService],
  declarations: [OndMarketingLandingComponent, OndMarketingListingComponent],
  exports: [OndMarketingLandingComponent],
})
export class OndMarketingLandingModule {}
